import { Logo } from '../components/Logo'
import { Aco } from '../components/Aco';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  NumberData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

const data = [
  {en: 'Alpha-pinene', ja: 'アルファ-ピネン', value:'11.50%'},
  {en: 'Camphene', ja: 'カンフェン', value:'0.04%'},
  {en: 'Beta-pinene', ja: 'ベータ-ピネン', value:'0.38%'},
  {en: 'Mycene', ja: 'ミルセン', value:'0.52%'},
  {en: 'Alpha-phellandrene', ja: 'アルファ-フェランドレン', value:'0.64%'},
  {en: 'Alpha-terpinene', ja: 'アルファ-テルピネン', value:'0.16%'},
  {en: 'p-cymene', ja: 'p-シメン', value:'3.94%'},
  {en: 'limonene', ja: 'リモネン', value:'5.61%'},
  {en: '1,8-cineole', ja: '1,8-シネオール', value:'72.54%'},
  {en: 'Trans-beta-ocimene', ja: 'トランス-ベータ-オキシメン', value:'0.06%'},
  {en: 'Terpinolene', ja: 'テルピノレン', value:'1.33%'},
  {en: 'Trans-pinocarveol', ja: 'トランス-ピノカルベオール', value:'0.06%'},
  {en: 'Terpinene-4-ol', ja: 'テルピネン-4-オール', value:'0.22%'},
  {en: 'Cryptone', ja: 'クリプトン', value:'0.09%'},
  {en: 'Alpha-terpineol', ja: 'アルファ-テルピネオール', value:'1.02%'},
  {en: 'Citronellol', ja: 'シトロネロール', value:'0.04%'},
  {en: 'Alpha-terpinyl acetate', ja: 'アルファ-テルピニルアセテート', value:'0.09%'},
  {en: 'Aromadendrene', ja: 'アロマデンドレン', value:'0.80%'},
  {en: 'Globulol', ja: 'グロブロール', value:'0.20%'},
]

export const EucalyptusGlobulus = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>
    
    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />
          
          <ProductTitle>ユーカリグロブルス</ProductTitle>
          <ProductSubtitle>Eucalyptus globulus</ProductSubtitle>
          
          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2025-03-01T09:00:00.000Z').toLocaleDateString()}</Paragraph>
          
          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>スペイン</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>葉</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>水蒸気蒸留法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Eucalyptus globulus</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>-</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>-</TableData>
              </TableRow>
            </tbody>
          </InfoTable>
          
          <SectionTitle>分析証明書</SectionTitle>
          
          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Eucalyptus globulus Oil-100% Organic ACO</li>
            <li>植物学名: Eucalyptus globulus</li>
          </List>
          
          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 透明で流動性のある液体</li>
            <li>香り: 特徴的</li>
            <li>比重: 0.900 〜 0.9250 @ 20°C</li>
            <li>屈折率: 1.4580 〜 1.4650 @ 20°C</li>
          </List>
          
          <SubSectionTitle>ガスクロマトグラフ分析結果</SubSectionTitle>
          <InfoTable>
            <tbody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableDataLabel>{item.ja}</TableDataLabel>
                  <NumberData>{item.value}</NumberData>
                </TableRow>
              ))}
            </tbody>
          </InfoTable>
        </MainContent>
        
        <SideContent>
          <AcoContainer>
            <Aco />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
